import { apiClient, getAuthHeader } from "./apiConfig";

export const fetchProfile = async (userId) => {
  const res = await apiClient.get(`/profile/profile-detail/${userId}`, getAuthHeader());
  return res.data;
};

export const updateProfile = async (userId, payload) => {
  const res = await apiClient.post(`/profile/update-profile/${userId}`, payload, getAuthHeader());
  return res.data;
};
